import React from "react";
import { ImageKit, Typography } from "@aph/ui-lib-humanx";
import styles from "./UserProfile.module.scss";

interface UserProfileProps {
  title?: string;
  imageUrl?: string;
  profileAlt?: string;
  titleTag?: string;
  className?: string;
  isImageCover?: boolean;
  imageSize?: number;
  marginBottom?: number;
  imageBG?: string;
  imageClassName?: string;
}

const UserProfile: React.FC<UserProfileProps> = (props) => {
  const {
    title,
    imageUrl,
    profileAlt = "profile",
    titleTag = "h2",
    className = "",
    isImageCover,
    imageSize,
    marginBottom,
    imageBG,
    imageClassName = "",
  } = props;

  return (
    <div className={`${styles.profileRoot} ${className}`}>
      {imageUrl ? (
        <div
          className={`${styles.imageBx} ${isImageCover ? styles.cover : ""} ${imageClassName}`}
          style={{
            height: `${imageSize}px`,
            width: `${imageSize}px`,
            marginBottom: `${marginBottom}px`,
            background: imageBG,
          }}
        >
          <ImageKit src={imageUrl} alt={profileAlt} height={48} width={48} className={styles.imgBx} />
        </div>
      ) : (
        <span className={`icon-user_icon2 ${styles.userIcon}`}>
          <span className="path1"></span>
          <span className="path2"></span>
          <span className="path3"></span>
          <span className="path4"></span>
          <span className="path5"></span>
          <span className="path6"></span>
          <span className="path7"></span>
          <span className="path8"></span>
        </span>
      )}
      {title && (
        <Typography component={titleTag} className={`${styles.title}`}>
          {title}
        </Typography>
      )}
    </div>
  );
};

export default UserProfile;
